import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './button';
import { cn } from '../../lib/utils';

interface FloatingAssistantButtonProps {
  className?: string;
}

const FloatingAssistantButton: React.FC<FloatingAssistantButtonProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/assistant');
  };

  return (
    <div className={cn(
      "fixed bottom-24 right-6 z-50",
      "md:right-8 lg:right-56 xl:right-64 2xl:right-96",
      className
    )}>
      <Button
        onClick={handleClick}
        size="icon"
        className={cn(
          "h-12 w-12 rounded-full shadow-lg hover:shadow-xl",
          "transition-all duration-300 ease-in-out",
          "hover:scale-110 active:scale-95",
          // Custom animation for friendly wave
          "hover:animate-none"
        )}
        style={{
          animation: 'friendlyWave 3s ease-in-out infinite'
        }}
      >
        <div className="relative">
          <img src="/logo-dark.svg" alt="Assistant" className="w-full h-full object-contain" />
          {/* Subtle glow effect */}
          <div className="absolute inset-0 rounded-full bg-white/20 animate-ping" />
        </div>
      </Button>
      
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 px-3 py-1 bg-gray-900 text-white text-sm rounded-lg opacity-0 hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
        Trợ lý AI
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900" />
      </div>
    </div>
  );
};

export default FloatingAssistantButton;
